import { all } from 'redux-saga/effects';

import SetupFinalsaga from './setup-final-saga';

export default function* rootSaga(action) {
	yield all([SetupFinalsaga(action)]);
}
